<template>
  <div class="flex h-screen w-screen items-center justify-center">
    <div class="text-2xl font-bold">
      <img src="/images/logo-fletcher.svg" alt="Fletcher Menu" class="w-80">
    </div>
  </div>
</template>
